var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.6 25.6",
    style: {
      enableBackground: "new 0 0 25.6 25.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000092444541356020479700000010925479099849666721_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    className: "st0",
    d: "M9.9,13.1c0,0.9-0.6,1.6-1.5,1.6c0,0,0,0,0,0H8.3c-0.9,0-1.6-0.6-1.6-1.5c0,0,0,0,0,0l0,0v-0.1 c0-0.9,0.7-1.6,1.5-1.6c0,0,0,0,0,0l0,0C9.1,11.5,9.8,12.1,9.9,13.1C9.9,13,9.9,13,9.9,13.1L9.9,13.1C9.9,13,9.9,13.1,9.9,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    className: "st0",
    d: "M13.1,11.5c0.9,0,1.6,0.6,1.6,1.5v0.1c0,0.9-0.7,1.6-1.5,1.6c0,0,0,0,0,0H13 c-0.9,0-1.6-0.7-1.6-1.6l0,0c0-0.9,0.7-1.6,1.5-1.6C13,11.5,13,11.5,13.1,11.5L13.1,11.5L13.1,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    className: "st0",
    d: "M17.9,14.7c-0.9,0-1.6-0.6-1.6-1.5c0,0,0,0,0,0l0,0v-0.1c0-0.9,0.6-1.6,1.5-1.6c0,0,0,0,0,0 l0,0c0.9-0.1,1.6,0.6,1.7,1.5c0,0,0,0,0,0v0.1c0,0.8-0.6,1.6-1.5,1.6H17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202-2",
    className: "st0",
    d: "M12.8,0C5.8,0,0,5.7,0,12.8s5.7,12.8,12.8,12.8c4.3,0,8.3-2.1,10.7-5.7 c1.4-2.1,2.2-4.6,2.2-7.1C25.6,5.8,19.9,0,12.8,0z M12.8,23.3C7,23.4,2.3,18.6,2.3,12.8S7,2.3,12.8,2.2c5.8,0,10.6,4.7,10.6,10.5 c0,0,0,0,0,0l0,0C23.3,18.6,18.6,23.3,12.8,23.3L12.8,23.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreActive);
export default __webpack_public_path__ + "static/media/more-active.92a6f5dc0956f921b4ee923c9b1672fc.svg";
export { ForwardRef as ReactComponent };